"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clamp;
function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-colorpicker/lib/util/clamp.js
// module id = 273
// module chunks = 0 1